import apiClient from './apiClient';

const taxRateService = {
  getAll: () => apiClient.get('/billing/tax-rates/'),
  getById: (id) => apiClient.get(`/billing/tax-rates/${id}/`),
  create: (data) => apiClient.post('/billing/tax-rates/', data),
  update: (id, data) => apiClient.patch(`/billing/tax-rates/${id}/`, data),
  remove: (id) => apiClient.del(`/billing/tax-rates/${id}/`),
};

export default taxRateService;
